import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const token = localStorage.getItem('authToken');

    if (token) {
      let cloned = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });

      return next(cloned);
    }

    return next(req);
};
